import React from "react";
import styled from "styled-components";
import hero from "../assets/hero.jpg";
export default function Hero() {
  return (
    <Section id="home">
      <div className="background">
        <img src={hero} alt="Rainbowl Background Image" />
        <div className="content">
          <div className="sale">
          <h1>Healthy, Fresh, and Delicious Bowls</h1>
          </div>

        </div>
        <div className="hero-text-wrapper">
          <p> Best lunch restaurant near me </p>
          <p> Berlin lunch spots </p>
          <p> Lunch restaurant in Wittenbergplatz</p>
          <p> Top places for lunch in Berlin</p>
          <p> "Affordable lunch in Berlin"</p>
          <p> Lunch deals Berlin</p>
          <p> Restaurants near Kurfürstenstraße</p>
          <p> Healthy superfood lunch in Berlin</p>
        </div>
      </div>
    </Section>
  );
}

const Section = styled.section`
  height: 100vh;
  width: 100vw;
  position: relative;
  .background {
    position: relative;
    height: 100%;
    img {
    z-index: 9; 
      position: absolute;
      object-fit: cover;
      width: 100%;
      height: 100%;
      filter: brightness(70%);
    }
  }
  .hero-text-wrapper {
    position: absolute;
    top: 0;
    z-index: 0;
  }
  .hero-text-wrapper p {
    color: white;
  }
  .content {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    z-index: 9;
    .sale {
      position: relative;
    width: 40%;
      left: 0%;
      img {
        height: 70vh;
      }
      h1 {
        color: white;
        position: absolute;
        top: 10vh;
        left: 20%;
        font-size: 2.5rem;
        span {
          display: block;
          font-size: 5vw;
        }
      }
    }
    .info {
    width: 100%;
      position: absolute;
      top: 40%;
      left: 25%;
      display: flex;
      align-items: flex-end;
      h2 {
        color: #f9c74f;
        font-size: 1.5rem;
      }
      em {
        color: white;
        width: 80%;
        text-align: end;
        font-size: 1.1rem;
        line-height: 2rem;
        letter-spacing: 0.1rem;
      }
      button {
        padding: 1rem 2rem;
        font-size: 1.4rem;
        background-color: #fc4958;
        border: none;
        color: white;
        font-weight: 800;
        letter-spacing: 0.2rem;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        &:hover {
          background-color: #f9c74f;
        }
      }
    }
  }
  @media screen and (min-width: 260px) and (max-width: 1080px) {
    .content {
      flex-direction: column;
      .sale {
        display: none;
      }
      .info {
        top: 25%;
        h2 {
          font-size: 2rem;
        }
        em {
          width: 90%;
        }
      }
    }
  }
`;
